import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PokeItem from "../Components/PokeItem";
import getAllPokemons from "../Services/getAllPokemons";

const PokemonList = () => {
  const [pokeList, setPokeList] = useState([]);
  const [arrOffsetPosition, setArrOffsetPosition] = useState(0);

  const userName = useSelector((state) => state.userName);
  const itemsForPage = useSelector((state) => state.itemsForPage);
  useEffect(() => {
    getAllPokemons(arrOffsetPosition, itemsForPage).then((res) => {
      setPokeList(res.data.results);
    });
  }, [arrOffsetPosition]);

  const list = pokeList.map((item) => (
    <PokeItem key={item.url} url={item.url} />
  ));

  return (
    <div>
      <img
        src="https://i.imgur.com/JoER25Z.png"
        className="mar-top3"
        style={{ height: "8vw" }}
      />
      <p>Welcome {userName}, here you can find your favorite pokemon</p>
      <br />
      <div className="mar"></div>
      <br />
      {arrOffsetPosition === 0 ? (
        <button
          className="boton "
          onClick={() => setArrOffsetPosition(itemsForPage)}
        >
          Next {itemsForPage}
        </button>
      ) : (
        <>
          <button
            className="boton"
            onClick={() =>
              setArrOffsetPosition(arrOffsetPosition - itemsForPage)
            }
          >
            Prev {itemsForPage}
          </button>
          <button
            className="boton"
            onClick={() =>
              setArrOffsetPosition(arrOffsetPosition + itemsForPage)
            }
          >
            Next {itemsForPage}
          </button>
        </>
      )}
      <br />

      <div className="cColumns cColumns3 t-normal  ">{list}</div>
      {arrOffsetPosition === 0 ? (
        <button
          className="boton"
          onClick={() => setArrOffsetPosition(arrOffsetPosition + itemsForPage)}
        >
          Next {itemsForPage}
        </button>
      ) : (
        <>
          <button
            className="boton"
            onClick={() =>
              setArrOffsetPosition(arrOffsetPosition - itemsForPage)
            }
          >
            Prev {itemsForPage}
          </button>
          <button
            className="boton"
            onClick={() =>
              setArrOffsetPosition(arrOffsetPosition + itemsForPage)
            }
          >
            Next {itemsForPage}
          </button>
        </>
      )}
      <div className="mar3"></div>
    </div>
  );
};

export default PokemonList;
